/**
 * May this caller read replacements at all?
 *
 * TWO PERMISSIONS, NOT ONE, mirroring `ReplacementPolicy::canRead()` on the
 * server — the identical shape `src/lib/permissions/escalations.ts` and
 * `justifications.ts` document, restated here because their history is
 * exactly the risk this one guards against.
 *
 * `replacement.fulfil` is admitted alongside `replacement.view` even though
 * every seeded role holding the first also holds the second today. That is
 * not redundancy: it is the M-10 lesson written down. An educator holding
 * only `escalation.act` could POST a comment on a record it got `403`
 * reading, and the fix — a read rule that admits every permission implying
 * a read — belongs on both sides of the wire. A per-user grant or a future
 * role edit is all it takes to reproduce that here.
 *
 * THIS IS THE ONLY PLACE THIS RULE MAY LIVE — imported by the nav gate
 * (`App.tsx`), the screen gate, and the case-detail panel, never copied
 * into any of them. `escalation.view` hid the escalations feature THREE
 * TIMES IN ONE MILESTONE precisely because the rule had three copies. If
 * this and `ReplacementPolicy::canRead()` ever disagree, the symptom is a
 * nav entry or panel that 403s, or a screen nobody can reach.
 */
export function canReadReplacements(permissions: readonly string[]): boolean {
  return permissions.includes('replacement.view') || permissions.includes('replacement.fulfil');
}
